import { Application } from "@hotwired/stimulus"
import CharLimitController from "./controllers/char_limit_controller"

window.EurokeyEmbedStimulus = {
  init(rootElement) {
    const app = new Application(rootElement)
    app.register("char-limit", CharLimitController)
    app.start()
  }
}
